import { useMemo } from 'react'
import SponsorService from 'src/service/SponsorService'
import ToastComponent from 'src/components/common/TaostComponent'

const TOOLBAR_COLORS = [
  '#000000',
  '#e60000',
  '#ff9900',
  '#ffff00',
  '#008a00',
  '#0066cc',
  '#9933ff',
  '#ffffff',
  '#facccc',
  '#ffebcc',
  '#ffffcc',
  '#cce8cc',
  '#cce0f5',
  '#ebd6ff',
  '#bbbbbb',
  '#f06666',
  '#ffc266',
  '#ffff66',
  '#66b966',
  '#66a3e0',
  '#c285ff',
  '#888888',
  '#a10000',
  '#b26b00',
  '#b2b200',
  '#006100',
  '#0047b2',
  '#6b24b2',
  '#444444',
  '#5c0000',
  '#663d00',
  '#666600',
  '#003700',
  '#002966',
  '#3d1466',
]

// Shared "About" editor config for the sponsor add/edit forms - keeps the toolbar and the
// server-side image upload handler identical in both.
const useSponsorQuillModules = (quillRef) =>
  useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          ['bold', 'italic', 'underline', 'strike'],
          [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
          ['image', 'link'],
          [{ color: TOOLBAR_COLORS }],
        ],
        handlers: {
          image: () => {
            const editor = quillRef.current?.getEditor()
            if (!editor) return

            const input = document.createElement('input')
            input.setAttribute('type', 'file')
            input.setAttribute('accept', 'image/*')
            input.click()

            input.onchange = async () => {
              const file = input.files[0]
              if (!file) return
              if (!/^image\//.test(file.type)) {
                ToastComponent('You could only upload images.', 'error')
                return
              }
              const formData = new FormData()
              formData.append('image', file)
              const res = await SponsorService.imageUplaod(formData)
              const url = res?.url
              editor.insertEmbed(editor.getSelection(true)?.index ?? 0, 'image', url)
            }
          },
        },
      },
    }),
    [quillRef],
  )

export default useSponsorQuillModules
